import { render, staticRenderFns } from "./RemoveTeamMemberModal.vue?vue&type=template&id=5779b8a4&"
import script from "./RemoveTeamMemberModal.vue?vue&type=script&lang=js&"
export * from "./RemoveTeamMemberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports